/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getInvoiceComments } from "api/services/invoice";
import { invoiceQueryKeys } from "./invoiceQueryKeys";

type GetInvoiceCommentsOptions = {
  invoiceId: string;
  options?: UseQueryOptions;
  queryFn?: any;
};

export const useGetInvoiceComments = (data: GetInvoiceCommentsOptions) =>
  useQuery({
    queryKey: invoiceQueryKeys.invoiceCommentsListing(data.invoiceId),
    queryFn: data.queryFn ? data.queryFn : () => getInvoiceComments(data.invoiceId).then((res) => res.data.results),
    ...data.options,
  });
